import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "All Results", path: "/all-result-list" },
  { label: "About Us", path: "/about" },
  { label: "Terms & Conditions", path: "/terms" },
  { label: "Privacy Policy", path: "/privacy" },
  { label: "Contact Us", path: "/contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  return (
    <>
      <header className="sle-header" data-testid="site-header">
        <div className="sle-logo" onClick={() => go("/")} data-testid="logo-home">
          <span className="s-shillong">Shillong</span>{" "}
          <span className="s-lucky">Lucky</span>{" "}
          <span className="s-ending">Ending</span>
        </div>
        <button
          className={`menu-btn ${open ? "open" : ""}`}
          onClick={() => setOpen((o) => !o)}
          data-testid="menu-toggle"
          aria-label="Menu"
          aria-expanded={open}
        >
          {open ? "✕" : "☰"}
        </button>
      </header>
      <div className="header-spacer" />
      {open && (
        <nav className="sle-menu" data-testid="nav-menu">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              onClick={() => setOpen(false)}
              data-testid={`nav-${l.path.replace(/\//g, "") || "home"}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      )}
    </>
  );
}
